import React from "react";
import styled from "styled-components";

import { DynamicButton, StyledText } from "../../../components/common/basic";

import { NewBackButton } from "../../../components/svgs";
import CongratsModal from "./component/CongratsModal";
import useCapturenShareStock from "./hooks/useCapturenShareStock";
import OutOfStockModal from "./component/OutOfStockModal";
import loadingGif from "../../../components/images/loader.gif";

const CapturenShareCapture = () => {
  const {
    history,
    captureAndShareData,
    captureImage,
    capture,
    currentItem,
    handleCaptureImage,
    background,
    text,
    showCongratsModal,
    showOutOfStockModal,
    setShowOutOfStockModal,
    retryCapture,
    loading,
  } = useCapturenShareStock();

  return (
    <>
      <Children>
        <div style={{ display: "flex", gap: "40px", alignItems: "center", marginBottom: "50px" }}>

          <BackButtonContainer
            onClick={() => {
              history.goBack();
            }}
          >
            <NewBackButton />
          </BackButtonContainer>
          <StyledText size={24}>Capture & Share</StyledText>
        </div>
        {
          loading ?
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img src={loadingGif} style={{ width: '48px' }} />
              <StyledText>Loading...</StyledText>
            </div>
            :
            <>
              <div style={{ marginBottom: "40px" }}>
                {captureAndShareData && (
                  <Image src={capture ? captureImage.imageUrl : currentItem?.imageUrl} />
                )}
              </div>
              <DynamicButton
                disabled={!!capture}
                onClick={handleCaptureImage}
                label={text}
                color={"#FFCC00"}
                textColor={"#000"}
              />
            </>
        }
      </Children>
      <CongratsModal isOpen={showCongratsModal} reward={captureImage?.name} />

      <OutOfStockModal
        isOpen={showOutOfStockModal}
        reward={captureImage?.name}
        onClose={() => setShowOutOfStockModal(false)}
        onOkClick={retryCapture}
      />
    </>
  );
};

const Children = styled.div`
  padding-top: 20px;
  min-height: 500px;
  max-height: 700px;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
`;

const Image = styled.img`
  width: 100%;
  height: 360px;
`;

export default CapturenShareCapture;
